import { Link, useLocation } from "react-router-dom";

interface BreadcrumbProps {
  customPath?: { label: string; path?: string }[];
}

export default function Breadcrumb({ customPath }: BreadcrumbProps) {
  const location = useLocation();

  const getBreadcrumbs = () => {
    if (customPath) return customPath;

    const paths = location.pathname.split("/").filter(Boolean);
    const breadcrumbs = [{ label: "首页", path: "/" }];

    if (paths[0] === "category" && paths[1]) {
      breadcrumbs.push({
        label: `分类：${decodeURIComponent(paths[1])}`,
        path: `/category/${paths[1]}`,
      });
    }
    if (paths[0] === "article" && paths[1]) {
      breadcrumbs.push({ label: "文章详情", path: undefined });
    }
    if (paths[0] === "about") {
      breadcrumbs.push({ label: "关于我们", path: "/about" });
    }

    return breadcrumbs;
  };

  const breadcrumbs = getBreadcrumbs();

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
      <ol className="flex items-center gap-1.5 text-xs md:text-sm flex-wrap">
        {breadcrumbs.map((crumb, index) => (
          <li key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
            )}
            {crumb.path ? (
              <Link
                to={crumb.path}
                className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
              >
                {crumb.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium">
                {crumb.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}